import { GEOMETRY } from "./drawConstants";
import { Position } from "geojson";
import { FeatureLike } from "ol/Feature";
import { GeometryType } from "../../../core/geo/types";
import { numberComparator } from "../../../core/comparators/numberComparator";

export const getGeometry = (feature: FeatureLike) => {
    return feature.get(GEOMETRY);
};

export const getCoordinates = (feature: FeatureLike) => {
    const geometry = getGeometry(feature);
    if (geometry.getType() === GeometryType.GEOMETRY_COLLECTION) {
        throw new Error("Unsupported geometry type");
    }
    return geometry.getCoordinates();
};

export const getFlatCoordinates = (feature: FeatureLike): Position[] => {
    const geometryCoordinates = getCoordinates(feature);
    return convertToFlatCoordinates(geometryCoordinates);
};

const isCoordinate = (coordinates: Position | Position[] | Position[][]): coordinates is Position => {
    return Array.isArray(coordinates) && coordinates.length === 2 && typeof coordinates[0] === "number";
};

export const flattenCoordinates = (coordinates: Position | Position[] | Position[][]): Position[] => {
    const resultCoordinates: Position[] = [];
    if (isCoordinate(coordinates)) {
        resultCoordinates.push(coordinates);
        return resultCoordinates;
    }

    return convertToFlatCoordinates(coordinates);
};

export const convertToFlatCoordinates = (coordinates: Position[] | Position[][]) => {
    return typeof coordinates[0][0] === "object" && typeof coordinates[0][0][0] === "number"
        ? (convert2dTo1d(coordinates as Position[][]) as Position[])
        : (coordinates as Position[]);
};

const convert2dTo1d = (coordinates: Position[][]) => {
    return coordinates.reduce((prev: Position[], next: Position[]) => prev.concat(next), []);
};

export const coordinatesEqual = (coordinate1: Position, coordinate2: Position) => {
    return numberComparator(coordinate1[0], coordinate2[0]) && numberComparator(coordinate1[1], coordinate2[1]);
};
